import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { formatCurrency } from '../../../../../../../../utils/functions'; // Adjust the import path as needed
import { FaPlus, FaSortUp, FaSortDown, FaArrowLeft, FaArrowRight, FaCog, FaChevronLeft, FaCheck } from 'react-icons/fa';
import { HiOutlinePencilSquare, HiOutlineTrash } from 'react-icons/hi2';
import { Item } from '../../../../types';
import { Button, Form } from 'react-bootstrap';
import {
  updateItemStateById,
  updateItemPriceById,
  updateItemLabelById, 
  updateItemNameById,
  DeleteItemsSelected,
  updateItemCategoryById
} from '../../../../../../../../crud/menu_api/items';
import { toast } from 'react-toastify';
import CreateItem from './components/CreateItem/CreateItem';
import UpdateItem from './components/UpdateItem/UpdateItem';
import DeleteItem from './components/DeleteItem/DeleteItem';
import MobileActionButtons from './components/MobileActionButtons/MobileActionButtons';
import './Table.scss';
import { getAllItemHolderCategoriesByLocalId } from '../../../../../../../../crud/menu_api/categories'; // Importa la función
import SearchDropdown from '../../../../../../../../components/common/SearchDropdown/SearchDropdown';
import { MenuCategoryNode } from '../../../../types/menu.types';

interface CategoryOption {
  category_id: number;
  category_name: string;
  menu_category_type_id: number | null;
  menu_category_type_name: string | null;
  menus: Array<{
    menu_id: number;
    menu_name: string;
  }>;
  is_main: boolean;
  local_id: number;
  local_name: string;
  state: boolean;
  isParent: boolean;
  isEmpty: boolean;
  parent_category_id: number | null;
  parent_category_name: string | null;
  workstation_id: number | null;
  workstation_name: string | null;
  created_at: string;
}

interface FilterOption {
  value: string | number;
  label: string;
}

interface TableProps {
  items: Item[];
  setSelectedCategory?: any;
  categoryId?: string | undefined | null;
  setData: (data: any[]) => void;
  originalItems: Item[];
  setOriginalItems: (data:  Item[]) => void;
  allItems: Item[];
  updateCategoryItems?: (updatedCategory: MenuCategoryNode) => void; // Nueva propiedad opcional
  onGoBack?: () => void; // Nueva propiedad para ir hacia atrás
  showMobileFilters?: boolean;
  onCloseMobileFilters?: () => void;
  onRegisterActions?: (actions: { openCreate: () => void; toggleSelection: () => void; deleteSelection: () => void; getSelectedCount: () => number }) => void;
  hasOriginalItems?: boolean; // Indica si hay items originales (antes de filtrar)
}

const Table: React.FC<TableProps> = ({
  items,
  categoryId,
  setData,
  originalItems,
  setOriginalItems,
  allItems,
  updateCategoryItems,
  onGoBack,
  showMobileFilters: externalShowMobileFilters,
  onCloseMobileFilters: externalOnCloseMobileFilters,
  onRegisterActions,
  hasOriginalItems = true,
}) => {
  const location = useLocation();

  const [localItems, setLocalItems] = useState<Item[]>(items);
  const [filteredItems, setFilteredItems] = useState<Item[]>(items);

  // Filter states
  const [selectedCategories, setSelectedCategories] = useState<FilterOption[]>([]);
  const [showOnlyActive, setShowOnlyActive] = useState(false);
  const [showOnlyInactive, setShowOnlyInactive] = useState(false);
  const [showOnlyWithStock, setShowOnlyWithStock] = useState(false);

  // Estados de edición para cada campo
  const [editPriceId, setEditPriceId] = useState<string | null>(null);
  const [editDeliveryPriceId, setEditDeliveryPriceId] = useState<string | null>(null);
  const [editedDeliveryPrice, setEditedDeliveryPrice] = useState<string>("");
  const [editedPrice, setEditedPrice] = useState<string>("");
  const [editLabelId, setEditLabelId] = useState<string | null>(null);
  const [editedLabel, setEditedLabel] = useState<string>("");
  const [editNameId, setEditNameId] = useState<string | null>(null);
  const [editedName, setEditedName] = useState<string>("");
  const [editDeskPriceId, setEditDeskPriceId] = useState<string | null>(null);
  const [editedDeskPrice, setEditedDeskPrice] = useState<string>("");
  const [editOnlinePriceId, setEditOnlinePriceId] = useState<string | null>(null);
  const [editedOnlinePrice, setEditedOnlinePrice] = useState<string>("");

  const [availableCategories, setAvailableCategories] = useState<CategoryOption[]>([]);
  const [loadingCategories, setLoadingCategories] = useState<boolean>(true);

  const [showSelection, setShowSelection] = useState(false);
  const [selectedItems, setSelectedItems] = useState<Item[]>([]);
  const [modalItem, setModalItem] = useState<Item | null>(null);
  const [internalShowMobileFilters, setInternalShowMobileFilters] = useState(false);
  // Note: filter UI moved to parent (ItemsDisplay). Table only renders data and actions.

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentItemId, setCurrentItemId] = useState<any>(null);

  const [isMobile, setIsMobile] = useState(false);

  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>(null);

  const handleSort = <K extends keyof Item>(key: K) => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: key as string, direction });

    const sortedItems = [...localItems].sort((a, b) => {
      if (typeof a[key] === 'string' && typeof b[key] === 'string') {
        return direction === 'asc'
          ? (a[key] as string).localeCompare(b[key] as string)
          : (b[key] as string).localeCompare(a[key] as string);
      }
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        return direction === 'asc' ? (a[key] as number) - (b[key] as number) : (b[key] as number) - (a[key] as number);
      }
      return 0;
    });

    setLocalItems(sortedItems);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Check initial size

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

useEffect(() => {
  setLocalItems([...items]);
  setFilteredItems([...items]);
}, [items]);

// Apply filtering logic
useEffect(() => {
  let filtered = [...localItems];

  // Filter by selected categories
 
  if (selectedCategories.length > 0) {

    //Casteamos el category_id a number para que coincida con el tipo en Item
    const categoryIds = selectedCategories.map(cat => Number(cat.value));
    filtered = filtered.filter(item => categoryIds.includes(Number(item.category_id)));
  }

  // Filter by active state
  if (showOnlyActive) {
    filtered = filtered.filter(item => item.state === true);
  }

  // Filter by inactive state
  if (showOnlyInactive) {
    filtered = filtered.filter(item => item.state === false);
  }

  // Filter by stock control
  if (showOnlyWithStock) {
    filtered = filtered.filter(item => item.stock_control === true);
  }

  setFilteredItems(filtered);
}, [localItems, selectedCategories, showOnlyActive, showOnlyInactive, showOnlyWithStock]);

// Load available categories when component mounts
useEffect(() => {
  const loadCategories = async () => {
    try {
      setLoadingCategories(true);
      // Assuming local_id = 1 for now, you can get this from props or context
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const localId = user.local_id || 0; // Use local_id from user or default to 1
      const response = await getAllItemHolderCategoriesByLocalId(localId);
      setAvailableCategories(response.data || []);
    } catch (error) {
      console.error('Error loading categories:', error);
      toast.error('Error al cargar las categorías');
    } finally {
      setLoadingCategories(false);
    }
  };

  loadCategories();
}, []);

// Auto-open CreateItem modal when navigating from EmptyCategory
useEffect(() => {
  const state = location.state as any;
  if (state?.openCreateItemModal) {
    // Clear the state to prevent reopening on subsequent renders
    window.history.replaceState({}, '', location.pathname);
    // Open the CreateItem modal
    setShowCreateModal(true);
  }
}, [location]);

  const handleSelectItem = (selectedItem: Item) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.some((item) => item.id === selectedItem.id);
      if (exists) {
        return prevItems.filter((item) => item.id !== selectedItem.id);
      } else {
        return [...prevItems, selectedItem];
      }
    });
  };

  const deleteItem = (id: string) => {
    setCurrentItemId(id);
    setShowDeleteModal(true);
  };

  // Cuando realmente se elimina el ítem (después de confirmar en el modal)
  // Suponiendo que tienes una función que elimina el ítem y actualiza el estado:
  const handleItemDeleted = (deletedItemId: string) => {
    const updatedItems = localItems.filter(item => item.id !== deletedItemId);
    setLocalItems(updatedItems);
    setData(updatedItems);
    setOriginalItems(originalItems.filter(item => item.id !== deletedItemId));
    // Llama a updateCategoryItems si está disponible
    if (updateCategoryItems && categoryId) {
      const updatedCategory = {
        id: Number(categoryId),
        name: updatedItems[0]?.category_name || '',
        subcategories: [], // No se actualizan aquí
        items: updatedItems,
      };
      updateCategoryItems(updatedCategory);
    }
  };

  // Guardar precio (botón "Guardar") - Optimistic Update
  const savePrice = (id: string) => {
    const itemToUpdate = originalItems.find(ing => ing.id === id);

    if (!itemToUpdate) {
      toast.error('Ingrediente no encontrado en la lista original.');
      return;
    }

    const newPrice = parseFloat(editedPrice);
    if (isNaN(newPrice)) {
      toast.error('Por favor ingrese un precio válido');
      return;
    }

    // Store original values for rollback
    const originalPrice = itemToUpdate.price;

    // Apply optimistic update immediately
    const optimisticItem: Item = {
      ...itemToUpdate,
      price: newPrice
    };

    const updatedLocalItems = localItems.map(item =>
      item.id === id ? optimisticItem : item
    );

    setLocalItems(updatedLocalItems);
    setData(updatedLocalItems);
    setOriginalItems(originalItems.map(item =>
      item.id === id ? optimisticItem : item
    ));
    setEditPriceId(null);

    // Show immediate feedback
    toast.success('Precio actualizado');

    // Make API call in background
    updateItemPriceById(Number(id), {
      price_type: 'price',
      price: newPrice,
    })
      .then((response) => {
        // Update with server response (in case server modifies the data)
        // Mantener las propiedades originales que no vienen en la respuesta
        const serverItem: Item = { ...itemToUpdate, ...(response as any).data };
        
        const finalLocalItems = localItems.map(item =>
          item.id === id ? serverItem : item
        );

        setLocalItems(finalLocalItems);
        setData(finalLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? serverItem : item
        ));
      })
      .catch(() => {
        // Rollback on failure
        const rolledBackLocalItems = localItems.map(item =>
          item.id === id ? { ...itemToUpdate, price: originalPrice } : item
        );

        setLocalItems(rolledBackLocalItems);
        setData(rolledBackLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? { ...itemToUpdate, price: originalPrice } : item
        ));

        toast.error('Error al actualizar el precio. Se revirtió el cambio.');
      });
  };

  // Guardar precio de delivery (botón "Guardar") - Optimistic Update
  const saveDeliveryPrice = (id: string) => {
    const itemToUpdate = originalItems.find(ing => ing.id === id);

    if (!itemToUpdate) {
      toast.error('Ingrediente no encontrado en la lista original.');
      return;
    }

    const newDeliveryPrice = parseFloat(editedDeliveryPrice);
    if (isNaN(newDeliveryPrice)) {
      toast.error('Por favor ingrese un precio de delivery válido');
      return;
    }

    // Store original values for rollback
    const originalDeliveryPrice = itemToUpdate.price_delivery;

    // Apply optimistic update immediately
    const optimisticItem: Item = {
      ...itemToUpdate,
      price_delivery: newDeliveryPrice
    };

    const updatedLocalItems = localItems.map(item =>
      item.id === id ? optimisticItem : item
    );

    setLocalItems(updatedLocalItems);
    setData(updatedLocalItems);
    setOriginalItems(originalItems.map(item =>
      item.id === id ? optimisticItem : item
    ));
    setEditDeliveryPriceId(null);

    // Show immediate feedback
    toast.success('Precio de delivery actualizado');

    // Make API call in background
    updateItemPriceById(Number(id), {
      price_type: 'price_delivery',
      price_delivery: newDeliveryPrice,
    })
      .then((response) => {
        // Update with server response
        const serverItem: Item = (response as any).data;
        
        const finalLocalItems = localItems.map(item =>
          item.id === id ? serverItem : item
        );

        setLocalItems(finalLocalItems);
        setData(finalLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? serverItem : item
        ));
      })
      .catch(() => {
        // Rollback on failure
        const rolledBackLocalItems = localItems.map(item =>
          item.id === id ? { ...itemToUpdate, price_delivery: originalDeliveryPrice } : item
        );

        setLocalItems(rolledBackLocalItems);
        setData(rolledBackLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? { ...itemToUpdate, price_delivery: originalDeliveryPrice } : item
        ));

        toast.error('Error al actualizar el precio de delivery. Se revirtió el cambio.');
      });
  };

  // Guardar nombre en carta (campo "label" en BD) - Optimistic Update
  const saveLabel = (id: string) => {
    const itemToUpdate = originalItems.find(ing => ing.id === id);

    if (!itemToUpdate) {
      toast.error('Ingrediente no encontrado en la lista original.');
      return;
    }

    if (!editedLabel.trim()) {
      toast.error('El nombre en carta no puede estar vacío');
      return;
    }

    // Store original values for rollback
    const originalLabel = itemToUpdate.label;

    // Apply optimistic update immediately
    const optimisticItem: Item = {
      ...itemToUpdate,
      label: editedLabel.trim()
    };

    const updatedLocalItems = localItems.map(item =>
      item.id === id ? optimisticItem : item
    );

    setLocalItems(updatedLocalItems);
    setData(updatedLocalItems);
    setOriginalItems(originalItems.map(item =>
      item.id === id ? optimisticItem : item
    ));
    setEditLabelId(null);

    // Show immediate feedback
    toast.success('Nombre en carta actualizado');

    // Make API call in background
    updateItemLabelById(Number(id), { label: editedLabel.trim() })
      .then((response) => {
        // Update with server response
        const serverItem: Item = {
          ...itemToUpdate,
          ...(response as any).data
        };
        
        const finalLocalItems = localItems.map(item =>
          item.id === id ? serverItem : item
        );

        setLocalItems(finalLocalItems);
        setData(finalLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? serverItem : item
        ));
      })
      .catch(() => {
        // Rollback on failure
        const rolledBackLocalItems = localItems.map(item =>
          item.id === id ? { ...itemToUpdate, label: originalLabel } : item
        );

        setLocalItems(rolledBackLocalItems);
        setData(rolledBackLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? { ...itemToUpdate, label: originalLabel } : item
        ));

        toast.error('Error al actualizar el nombre en carta. Se revirtió el cambio.');
      });
  };

  // Guardar nombre interno/abreviatura (campo "item_name" en BD) - Optimistic Update
  const saveName = (id: string) => {
    const itemToUpdate = originalItems.find(ing => ing.id === id);

    if (!itemToUpdate) {
      toast.error('Ingrediente no encontrado en la lista original.');
      return;
    }

    if (!editedName.trim()) {
      toast.error('El nombre interno no puede estar vacío');
      return;
    }

    // Store original values for rollback
    const originalName = itemToUpdate.item_name;

    // Apply optimistic update immediately
    const optimisticItem: Item = {
      ...itemToUpdate,
      item_name: editedName?.trim() ?? ""
    };

    const updatedLocalItems = localItems.map(item =>
      item.id === id ? optimisticItem : item
    );

    setLocalItems(updatedLocalItems);
    setData(updatedLocalItems);
    setOriginalItems(originalItems.map(item =>
      item.id === id ? optimisticItem : item
    ));
    setEditNameId(null);

    // Show immediate feedback
    toast.success('Nombre interno actualizado');

    // Make API call in background
    updateItemNameById(Number(id), { item_name: editedName?.trim() ?? "" })
      .then((response) => {
        // Update with server response
        const serverItem: Item = {
          ...itemToUpdate,
          ...(response as any).data
        };
        
        const finalLocalItems = localItems.map(item =>
          item.id === id ? serverItem : item
        );

        setLocalItems(finalLocalItems);
        setData(finalLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? serverItem : item
        ));
      })
      .catch(() => {
        // Rollback on failure
        const rolledBackLocalItems = localItems.map(item =>
          item.id === id ? { ...itemToUpdate, item_name: originalName } : item
        );

        setLocalItems(rolledBackLocalItems);
        setData(rolledBackLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? { ...itemToUpdate, item_name: originalName } : item
        ));

        toast.error('Error al actualizar el nombre interno. Se revirtió el cambio.');
      });
  };

  // Cambiar categoría del item - Optimistic Update
  const handleCategoryChange = async (itemId: string, newCategoryId: number) => {
    const itemToUpdate = originalItems.find(item => item.id === itemId);

    if (!itemToUpdate) {
      toast.error('Item no encontrado en la lista original.');
      return;
    }

    // Find the new category info
    const newCategory = availableCategories.find(cat => cat.category_id === newCategoryId);
    
    if (!newCategory) {
      toast.error('Categoría no encontrada');
      return;
    }

    // Store original values for rollback
    const originalCategoryId = itemToUpdate.category_id;
    const originalCategoryName = itemToUpdate.category_name;

    // Apply optimistic update immediately
    const optimisticItem: Item = {
      ...itemToUpdate,
      category_id: String(newCategoryId),
      category_name: newCategory.category_name
    };

    const updatedLocalItems = localItems.map(item =>
      item.id === itemId ? optimisticItem : item
    );

    setLocalItems(updatedLocalItems);
    setData(updatedLocalItems);
    setOriginalItems(originalItems.map(item =>
      item.id === itemId ? optimisticItem : item
    ));

    // Show immediate feedback
    toast.success(`Categoría actualizada a "${newCategory.category_name}"`);

    try {
      // Make API call in background
      await updateItemCategoryById(Number(itemId), newCategoryId);
      
      // API call succeeded - no need to update UI again since optimistic update was correct
    } catch (error) {
      // Rollback on failure
      const rolledBackLocalItems = localItems.map(item =>
        item.id === itemId ? { 
          ...itemToUpdate, 
          category_id: originalCategoryId, 
          category_name: originalCategoryName 
        } : item
      );

      setLocalItems(rolledBackLocalItems);
      setData(rolledBackLocalItems);
      setOriginalItems(originalItems.map(item =>
        item.id === itemId ? { 
          ...itemToUpdate, 
          category_id: originalCategoryId, 
          category_name: originalCategoryName 
        } : item
      ));

      console.error('Error updating item category:', error);
      toast.error('Error al actualizar la categoría. Se revirtió el cambio.');
    }
  };

  // --------- Funciones para entrar en modo edición --------- //
  const handlePriceEdit = (item: Item) => {
    setEditPriceId(item.id);
    setEditedPrice(String(item.price ?? "")); 
  };

  const handleDeliveryPriceEdit = (item: Item) => {
    setEditDeliveryPriceId(item.id);
    setEditedDeliveryPrice(String(item.price_delivery ?? ""));
  };

  const handleLabelEdit = (item: Item) => {
    setEditLabelId(item.id);
    setEditedLabel(item.label ?? "");
  };

  const handleNameEdit = (item: Item) => {
    setEditNameId(item.id);
    setEditedName(item.item_name?.trim() ?? "");
  };

  const handleDeskPriceEdit = (item: Item) => {
  setEditDeskPriceId(item.id);
  setEditedDeskPrice(String(item.price_desk ?? ""));
};

const handleOnlinePriceEdit = (item: Item) => {
  setEditOnlinePriceId(item.id);
  setEditedOnlinePrice(String(item.price_online ?? ""));
};

const saveDeskPrice = (id: string) => {
  const itemToUpdate = originalItems.find(ing => ing.id === id);
  if (!itemToUpdate) { toast.error('Ingrediente no encontrado en la lista original.'); return; }

  const newDeskPrice = parseFloat(editedDeskPrice);
  if (isNaN(newDeskPrice)) { toast.error('Por favor ingrese un precio de caja válido'); return; }

  const originalDeskPrice = itemToUpdate.price_desk;

  const optimisticItem: Item = { ...itemToUpdate, price_desk: newDeskPrice };
  const updated = localItems.map(i => i.id === id ? optimisticItem : i);

  setLocalItems(updated);
  setData(updated);
  setOriginalItems(originalItems.map(i => i.id === id ? optimisticItem : i));
  setEditDeskPriceId(null);
  toast.success('Precio de caja actualizado');

  updateItemPriceById(Number(id), { price_type: 'price_desk', price_desk: newDeskPrice })
    .then((response) => {
      const serverItem: Item = { ...itemToUpdate, ...(response as any).data };
      const finalItems = localItems.map(i => i.id === id ? serverItem : i);
      setLocalItems(finalItems);
      setData(finalItems);
      setOriginalItems(originalItems.map(i => i.id === id ? serverItem : i));
    })
    .catch(() => {
      const rolledBack = localItems.map(i => i.id === id ? { ...itemToUpdate, price_desk: originalDeskPrice } : i);
      setLocalItems(rolledBack);
      setData(rolledBack);
      setOriginalItems(originalItems.map(i => i.id === id ? { ...itemToUpdate, price_desk: originalDeskPrice } : i));
      toast.error('Error al actualizar el precio de caja. Se revirtió el cambio.');
    });
};

const saveOnlinePrice = (id: string) => {
  const itemToUpdate = originalItems.find(ing => ing.id === id);
  if (!itemToUpdate) { toast.error('Ingrediente no encontrado en la lista original.'); return; }

  const newOnlinePrice = parseFloat(editedOnlinePrice);
  if (isNaN(newOnlinePrice)) { toast.error('Por favor ingrese un precio online válido'); return; }

  const originalOnlinePrice = itemToUpdate.price_online;

  const optimisticItem: Item = { ...itemToUpdate, price_online: newOnlinePrice };
  const updated = localItems.map(i => i.id === id ? optimisticItem : i);

  setLocalItems(updated);
  setData(updated);
  setOriginalItems(originalItems.map(i => i.id === id ? optimisticItem : i));
  setEditOnlinePriceId(null);
  toast.success('Precio online actualizado');

  updateItemPriceById(Number(id), { price_type: 'price_online', price_online: newOnlinePrice })
    .then((response) => {
      const serverItem: Item = { ...itemToUpdate, ...(response as any).data };
      const finalItems = localItems.map(i => i.id === id ? serverItem : i);
      setLocalItems(finalItems);
      setData(finalItems);
      setOriginalItems(originalItems.map(i => i.id === id ? serverItem : i));
    })
    .catch(() => {
      const rolledBack = localItems.map(i => i.id === id ? { ...itemToUpdate, price_online: originalOnlinePrice } : i);
      setLocalItems(rolledBack);
      setData(rolledBack);
      setOriginalItems(originalItems.map(i => i.id === id ? { ...itemToUpdate, price_online: originalOnlinePrice } : i));
      toast.error('Error al actualizar el precio online. Se revirtió el cambio.');
    });
};

  // ---------------------------------------------------------- //
  
  /**
   * Alterna el estado de un ítem con actualización optimista
   */
  const toggleItemState = (id: string) => {
    const itemToUpdate = originalItems.find(ing => ing.id === id);

    if (!itemToUpdate) {
      toast.error('Ingrediente no encontrado en la lista original.');
      return;
    }

    // Store original state for rollback
    const originalState = itemToUpdate.state;
    const newState = !originalState;

    // Apply optimistic update immediately
    const optimisticItem: Item = {
      ...itemToUpdate,
      state: newState
    };

    const updatedLocalItems = localItems.map(item =>
      item.id === id ? optimisticItem : item
    );

    setLocalItems(updatedLocalItems);
    setData(updatedLocalItems);
    setOriginalItems(originalItems.map(item =>
      item.id === id ? optimisticItem : item
    ));

    // Show immediate feedback
    toast.success(`Item ${newState ? 'activado' : 'desactivado'}`);

    // Make API call in background
    updateItemStateById(Number(id), { state: newState })
      .then((response) => {
        // Update with server response
        const serverItem: Item = (response as any).data;

        const finalLocalItems = localItems.map(item =>
          item.id === id ? serverItem : item
        );

        setLocalItems(finalLocalItems);
        setData(finalLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? serverItem : item
        ));
      })
      .catch(() => {
        // Rollback on failure
        const rolledBackLocalItems = localItems.map(item =>
          item.id === id ? { ...itemToUpdate, state: originalState } : item
        );

        setLocalItems(rolledBackLocalItems);
        setData(rolledBackLocalItems);
        setOriginalItems(originalItems.map(item =>
          item.id === id ? { ...itemToUpdate, state: originalState } : item
        ));

        toast.error('Error al actualizar el estado. Se revirtió el cambio.');
      });
  };

// Dentro de tu componente Table
const handleUpdateItem = (item: Item) => {
  // en lugar de setSelectedItem, pasas 'item' directo al modal
  setModalItem(item);
  setShowUpdateModal(true);
};

  const handleDeleteItems = async () => {
    if (selectedItems.length === 0) {
      toast.error('No has seleccionado ningún ítem para eliminar.');
      return;
    }
  
    const itemIds = selectedItems.map(item => item.id);
  
    try {
      await DeleteItemsSelected(itemIds); 
      toast.success('Ítems eliminados correctamente.');
      
      // Optimistic UI update instead of page reload
      const updatedLocal = localItems.filter(item => !itemIds.includes(item.id));
      const updatedOriginal = originalItems.filter(item => !itemIds.includes(item.id));
      setLocalItems(updatedLocal);
      setData(updatedLocal);
      setOriginalItems(updatedOriginal);
      setSelectedItems([]);
      setShowSelection(false);
    } catch (error) {
      toast.error('Hubo un error al eliminar los ítems.');
    }
  };

    // Expose actions to parent if requested
    useEffect(() => {
      if (typeof onRegisterActions === 'function') {
        onRegisterActions({
          openCreate: () => setShowCreateModal(true),
          toggleSelection: () => {
            if (showSelection) { setSelectedItems([]); }
            setShowSelection(!showSelection);
          },
          deleteSelection: handleDeleteItems,
          getSelectedCount: () => selectedItems.length,
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onRegisterActions, showSelection, selectedItems]);

  const renderSortIcon = (key: string) => {
    if (sortConfig?.key === key) {
      return sortConfig.direction === 'asc' ? <FaSortUp /> : <FaSortDown />;
    }
    return null;
  };

  const [showingPriceType, setShowingPriceType] = useState<'price' | 'price_delivery' | 'price_desk' | 'price_online'>('price'); // Ahora acepta cuatro valores

  // ==========================================================================
  // MOBILE CARD VIEW - Compact list layout for mobile devices
  // ==========================================================================
  const renderMobileView = () => (
    <div className="items-mobile-view">
      {filteredItems.map((item) => (
        <div 
          key={item.id} 
          className={`item-mobile-card ${!item.state ? 'inactive' : ''}`}
          onClick={() => handleUpdateItem(item)}
        >
          {/* Selection checkbox (when in selection mode) */}
          {showSelection && (
            <div 
              className="card-checkbox"
              onClick={(e) => {
                e.stopPropagation();
                handleSelectItem(item);
              }}
            >
              <div className="mp-radio-button">
                <input
                  id={`mobile-checkbox-${item.id}`}
                  type="checkbox"
                  name="isSelected"
                  checked={selectedItems.some(i => i.id === item.id)}
                  onChange={() => handleSelectItem(item)}
                />
                <label htmlFor={`mobile-checkbox-${item.id}`}></label>
              </div>
            </div>
          )}

          {/* Left: Info */}
          <div className="card-info">
            <span className="card-name">{item.label || item.item_name}</span>
            <div className="card-meta">
              <span className="meta-price">{formatCurrency(item.price)}</span>
              {item.category_name && <span className="meta-category">{item.category_name}</span>}
              {!item.state && <span className="meta-inactive">Inactivo</span>}
            </div>
          </div>

          {/* Right: Actions */}
          <div className="card-actions" onClick={(e) => e.stopPropagation()}>
            <label className="switch" onClick={() => toggleItemState(item.id)}>
              <input type="checkbox" checked={item.state} onChange={() => {}} />
              <span className="slider round"></span>
            </label>
            <button className="mp-btn-icon mp-btn-icon-danger" onClick={() => deleteItem(item.id)} title="Eliminar">
              <HiOutlineTrash size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );

  // ==========================================================================
  // DESKTOP TABLE VIEW - Traditional table for larger screens
  // ==========================================================================
  const renderTable = () => (
    <>
      <div className='table-responsive'>
        <div className="overflow-x-auto overflow-y-auto mp-scrollbar items-scroll-area">
        <table className="mp-table items-table">
          <thead className="mp-table-head">
            <tr className='no_pagination'>
              {showSelection && <th className='no_pagination col-select'></th>}
              {/* ⚠️ RECORDATORIO CRÍTICO SOBRE NOMENCLATURA ⚠️
                  - label (BD)     = Nombre EN CARTA (bonito)    → se muestra en columna "Nombre"
                  - item_name (BD) = Nombre INTERNO (normalizado) → se muestra en columna "Abreviatura"
              */}
              <th className='no_pagination col-name' onClick={() => handleSort('label')}>
                Nombre {renderSortIcon('label')}
              </th>
              <th className='no_pagination no-responsive col-label' onClick={() => handleSort('item_name')}>
                Abreviatura {renderSortIcon('item_name')}
              </th>
              <th className='no_pagination no-responsive col-category' onClick={() => handleSort('category_name')}>
                Categoría {renderSortIcon('category_name')}
              </th>
              <th className='no_pagination col-price price-column'>
                <span className='price-column-title'>
                  <FaArrowLeft
                    className={`price-nav-arrow ${showingPriceType === 'price' ? 'disabled' : ''}`}
                    onClick={() => setShowingPriceType(
                      showingPriceType === 'price_delivery' ? 'price' :
                      showingPriceType === 'price_desk' ? 'price_delivery' :
                      showingPriceType === 'price_online' ? 'price_desk' : 'price'
                    )}
                  />
                  <span className="price-type-label">
                    {showingPriceType === 'price' && 'Precio'}
                    {showingPriceType === 'price_delivery' && '$ Delivery'}
                    {showingPriceType === 'price_desk' && '$ Caja'}
                    {showingPriceType === 'price_online' && '$ Online'}
                  </span>
                  <FaArrowRight
                    className={`price-nav-arrow ${showingPriceType === 'price_online' ? 'disabled' : ''}`}
                    onClick={() => setShowingPriceType(
                      showingPriceType === 'price' ? 'price_delivery' :
                      showingPriceType === 'price_delivery' ? 'price_desk' :
                      showingPriceType === 'price_desk' ? 'price_online' : 'price_online'
                    )}
                  />
                </span>
              </th>
              <th className='no_pagination col-toggle' onClick={() => handleSort('state')}>
                Activo {renderSortIcon('state')}
              </th>
              <th className='no_pagination col-actions'>{isMobile ? <FaCog /> : 'Acciones'}</th>
            </tr>
          </thead>
          <tbody className="mp-table-body">
            {filteredItems.map((item) => (
              <tr key={item.id}>
                {showSelection && (
                  <td>
                    <div className="mp-radio-button">
                      <input
                        id={`checkbox-${item.id}`}
                        type="checkbox"
                        name="isSelected"
                        checked={selectedItems.some(i => i.id === item.id)}
                        onChange={() => handleSelectItem(item)}
                      />
                      <label
                        htmlFor={`checkbox-${item.id}`}
                      ></label>
                    </div>
                  </td>
                )}

                {/* ========== NOMBRE EN CARTA (label en BD) ========== */}
                {/* Este es el nombre bonito que se muestra en la carta */}
                <td
                className={`linkable-item-cell col-name ${editLabelId === item.id ? 'is-editing' : ''}`}
                onClick={() => editLabelId !== item.id && handleLabelEdit(item)}
              >
                {editLabelId === item.id ? (
                  <div className="editable-cell-wrapper" onClick={(e) => e.stopPropagation()}>
                    <Form.Control
                      type="text"
                      className="mp-input-inline"
                      value={editedLabel}
                      onChange={e => setEditedLabel(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') { e.stopPropagation(); saveLabel(item.id); }
                        if (e.key === 'Escape') { e.stopPropagation(); setEditLabelId(null); setEditedLabel(item.label ?? ""); }
                      }}
                      autoFocus
                    />
                    <button className="ticket-save-btn" title="Guardar" onClick={(e) => { e.stopPropagation(); saveLabel(item.id); }}>
                      <FaCheck />
                    </button>
                  </div>
                ) : (
                  item.label
                )}
              </td>

              {/* ========== NOMBRE INTERNO/ABREVIATURA (item_name en BD) ========== */}
              {/* Este es el nombre normalizado sin caracteres especiales */}
              <td
                className={`linkable-item-cell no-responsive col-label ${editNameId === item.id ? 'is-editing' : ''}`}
                onClick={() => editNameId !== item.id && handleNameEdit(item)}
              >
                {editNameId === item.id ? (
                  <div className="editable-cell-wrapper" onClick={(e) => e.stopPropagation()}>
                    <Form.Control
                      type="text"
                      className="mp-input-inline"
                      value={editedName}
                      onChange={e => {
                        // Only allow alphanumeric and basic characters, no tildes or ñ
                        const value = e.target.value;
                        const sanitized = value.replace(/[^a-zA-Z0-9\s_-]/g, '');
                        setEditedName(sanitized);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') { e.stopPropagation(); saveName(item.id); }
                        if (e.key === 'Escape') { e.stopPropagation(); setEditNameId(null); setEditedName(item.item_name?.trim() ?? ""); }
                      }}
                      autoFocus
                    />
                    <button className="ticket-save-btn" title="Guardar" onClick={(e) => { e.stopPropagation(); saveName(item.id); }}>
                      <FaCheck />
                    </button>
                  </div>
                ) : (
                  item.item_name?.trim()
                )}
              </td>

                {/* ---------- CATEGORÍA DROPDOWN ---------- */}
                <td className='no-responsive'>
                  <div className="category-dropdown-container">
                    <SearchDropdown
                      items={availableCategories.filter(category => category.state).sort((a, b) => {
                        if (a.parent_category_name && !b.parent_category_name) return 1;
                        if (!a.parent_category_name && b.parent_category_name) return -1;
                        if (a.parent_category_name !== b.parent_category_name) {
                          return (a.parent_category_name || '').localeCompare(b.parent_category_name || '');
                        }
                        return a.category_name.localeCompare(b.category_name);
                      })}
                      selected={availableCategories.find(cat => String(cat.category_id) === String(item.category_id)) || null}
                      setSelected={(selectedCat) => {
                        if (selectedCat && selectedCat.category_id) {
                          handleCategoryChange(item.id, selectedCat.category_id);
                        }
                      }}
                      displayProperty="category_name"
                      idProperty="category_id"
                      placeholder={loadingCategories ? 'Cargando...' : 'Seleccionar categoría'}
                    />
                    {!loadingCategories && availableCategories.length === 0 && (
                      <div className="no-categories-message">
                        <small className="no-categories-hint">
                          No hay categorías disponibles
                        </small>
                      </div>
                    )}
                  </div>
                </td>

                {/* ---------- COLUMNA DE PRECIO/DELIVERY/CAJA ---------- */}
                <td>
                  {showingPriceType === 'price' ? (
                    editPriceId === item.id ? (
                      <div className="editable-cell-wrapper">
                        <Form.Control
                          className="mp-input-table"
                          type="text"
                          value={editedPrice}
                          onChange={e => setEditedPrice(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.stopPropagation();
                              savePrice(item.id);
                            }
                          }}
                          autoFocus
                        />
                        <Button
                          variant="none"
                          size="sm"
                          className='save-change-buttom-item'
                          onClick={(e) => {
                            e.stopPropagation();
                            savePrice(item.id);
                          }}
                        >
                          <FaCheck />
                        </Button>
                      </div>
                    ) : (
                      <div
                        className="price-display-cell"
                        onClick={() => handlePriceEdit(item)}
                      >
                        {formatCurrency(item.price)}
                      </div>
                    )
                  ) : showingPriceType === 'price_delivery' ? (
                    editDeliveryPriceId === item.id ? (
                      <div className="editable-cell-wrapper" onClick={(e) => e.stopPropagation()}>
                        <Form.Control
                          className="mp-input-inline"
                          type="text"
                          value={editedDeliveryPrice}
                          onChange={e => setEditedDeliveryPrice(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') { e.stopPropagation(); saveDeliveryPrice(item.id); }
                            if (e.key === 'Escape') { e.stopPropagation(); setEditDeliveryPriceId(null); setEditedDeliveryPrice(String(item.price_delivery ?? "")); }
                          }}
                          autoFocus
                        />
                        <button
                          className="ticket-save-btn"
                          title="Guardar"
                          onClick={(e) => { e.stopPropagation(); saveDeliveryPrice(item.id); }}
                        >
                          <FaCheck />
                        </button>
                      </div>
                    ) : (
                      <div className="price-display-cell" onClick={() => handleDeliveryPriceEdit(item)}>
                        {formatCurrency(item.price_delivery)}
                      </div>
                    )
                  ) : showingPriceType === 'price_desk' ? (
                    // Mostrar precio caja (price_desk)
                    editDeskPriceId === item.id ? (
                      <div className="editable-cell-wrapper" onClick={(e) => e.stopPropagation()}>
                        <Form.Control
                          className="mp-input-inline"
                          type="text"
                          value={editedDeskPrice}
                          onChange={e => setEditedDeskPrice(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') { e.stopPropagation(); saveDeskPrice(item.id); }
                            if (e.key === 'Escape') { e.stopPropagation(); setEditDeskPriceId(null); setEditedDeskPrice(String(item.price_desk ?? "")); }
                          }}
                          autoFocus
                        />
                        <button
                          className="ticket-save-btn"
                          title="Guardar"
                          onClick={(e) => { e.stopPropagation(); saveDeskPrice(item.id); }}
                        >
                          <FaCheck />
                        </button>
                      </div>
                    ) : (
                      <div
                        className="price-display-cell"
                        onClick={() => handleDeskPriceEdit(item)}
                      >
                        {formatCurrency(item.price_desk)}
                      </div>
                    )
                  ) : (
                    // Mostrar precio online (price_online)
                    editOnlinePriceId === item.id ? (
                      <div className="editable-cell-wrapper" onClick={(e) => e.stopPropagation()}>
                        <Form.Control
                          className="mp-input-inline"
                          type="text"
                          value={editedOnlinePrice}
                          onChange={e => setEditedOnlinePrice(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') { e.stopPropagation(); saveOnlinePrice(item.id); }
                            if (e.key === 'Escape') { e.stopPropagation(); setEditOnlinePriceId(null); setEditedOnlinePrice(String(item.price_online ?? "")); }
                          }}
                          autoFocus
                        />
                        <button
                          className="ticket-save-btn"
                          title="Guardar"
                          onClick={(e) => { e.stopPropagation(); saveOnlinePrice(item.id); }}
                        >
                          <FaCheck />
                        </button>
                      </div>
                    ) : (
                      <div
                        className="price-display-cell"
                        onClick={() => handleOnlinePriceEdit(item)}
                      >
                        {formatCurrency(item.price_online)}
                      </div>
                    )
                  )
                  }
                </td>
                {/* ---------- FIN COLUMNA PRECIO/DELIVERY/CAJA/ONLINE ---------- */}

                {/* ---------- ACTIVO (TOGGLE) ---------- */}
                <td>
                  <label className="switch">
                    <input
                      className='toggle-switch-item-checkbox'
                      type="checkbox"
                      checked={item.state}
                      onChange={() => toggleItemState(item.id)}
                    />
                    <span className="slider round"></span>
                  </label>
                </td>

             

                {/* ---------- ACCIONES (EDIT / DELETE) ---------- */}
                <td>
                  <div className='flex items-center justify-center gap-1.5'>
                    <button
                      className="mp-btn-icon"
                      onClick={() => handleUpdateItem(item)}
                      title="Editar"
                    >
                      <HiOutlinePencilSquare size={16} />
                    </button>
                    <button
                      className="mp-btn-icon mp-btn-icon-danger"
                      onClick={() => deleteItem(item.id)}
                      title="Eliminar"
                    >
                      <HiOutlineTrash size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className='custom-table-div'>
        {/* Go Back Button - keep this separate */}
        {onGoBack && (
          <div className="go-back-container">
            <Button variant="none" className="mp-button light" onClick={onGoBack}>
              <FaChevronLeft /> Volver
            </Button>
          </div>
        )}

        {localItems.length === 0 && !hasOriginalItems && (
          <div className="no-data-available">
            <div className='no-data-available-message'>
              No has creado ningún item aún!
            </div>
            <Button
              className='no-data-available-button'
              onClick={() => setShowCreateModal(true)}
            >
              <FaPlus/> Crear item 
            </Button>
          </div>
        )}

        {hasOriginalItems && (
          <div className="table-with-sticky-header">
            {/* Sticky Header Section - Always visible when there are original items */}
            <div className="sticky-header-section">
              {/* Filters and action buttons are rendered in parent ItemsDisplay */}
            </div>

            {localItems.length === 0 && (
              <div className="no-data-available">
                <div className='no-data-available-message'>
                  No se encontraron resultados para tu búsqueda
                </div>
              </div>
            )}

            {localItems.length > 0 && (
              <>
                {/* Mobile Action Buttons - Only visible on mobile */}
                <MobileActionButtons
                  showSelection={showSelection}
                  selectedItemsCount={selectedItems.length}
                  onCreateItem={() => setShowCreateModal(true)}
                  onToggleSelection={() => {
                    if (showSelection) {
                      setSelectedItems([]);
                    }
                    setShowSelection(!showSelection);
                  }}
                  onDeleteSelection={selectedItems.length > 0 ? handleDeleteItems : undefined}
                />

                {/* Scrollable Table Section */}
                <div className="mp-table-card items-table-card">
                  {filteredItems.length !== 0 && (
                    <>
                      {/* Mobile Card View */}
                      {renderMobileView()}
                      {/* Desktop Table View */}
                      {renderTable()}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>

      
      {/* Modales */}
      <CreateItem
        show={showCreateModal}
        handleClose={() => setShowCreateModal(false)}
        categoryId={categoryId}
        items={localItems}
        setItems={setLocalItems}
        setData={setData}
        originalItems={originalItems}
        setOriginalItems={setOriginalItems}
        allItems={allItems}
        updateCategoryItems={updateCategoryItems} // NUEVO
      />
      <UpdateItem
        show={showUpdateModal}
        handleClose={() => setShowUpdateModal(false)}
        item={modalItem}
        items={localItems}
        setItems={setLocalItems}
        setData={setData}
        originalItems={originalItems}
        setOriginalItems={setOriginalItems}
        categoryId={categoryId}
      />
      <DeleteItem
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        itemId={currentItemId}
        items={localItems}
        setItems={setLocalItems}
        setData={setData}
        originalItems={originalItems}
        setOriginalItems={setOriginalItems}
        onItemDeleted={handleItemDeleted} // NUEVO
      />
    </>
  );
};

export default Table;
